<!--Only for JPPC user-->
<template>
  <div>
    <p class="desc">本人確認情報の申請ステータスが承認済の場合、出金申請が可能です。</p>
    <div class="content_wrap">
      <div>
        <h3>
          申請ステータス : <span :class="statusClass">{{ registeredData.status }}</span>
        </h3>
        <div class="line" />
        <div>
          <div class="table_row">
            <p class="table_name">名前 (漢字)</p>
            <p class="name_text">{{ registeredData.familyName }} {{ registeredData.firstName }}</p>
          </div>
          <div class="table_row">
            <p class="table_name">名前 (カタカナ)</p>
            <p class="name_text">{{ registeredData.familyNameKana }} {{ registeredData.firstNameKana }}</p>
          </div>
          <div class="table_row">
            <p class="table_name">メールアドレス</p>
            <p>{{ registeredData.email }}</p>
          </div>
          <div class="table_row">
            <p class="table_name">電話番号</p>
            <p>{{ registeredData.tellNumber }}</p>
          </div>
          <div class="table_row">
            <p class="table_name">生年月日</p>
            <p>{{ registeredData.birthday }}</p>
          </div>
          <div class="table_row">
            <p class="table_name">郵便番号</p>
            <p>{{ registeredData.postCode }}</p>
          </div>
          <div class="table_row">
            <p class="table_name">都道府県</p>
            <p>{{ registeredData.prefecture }}</p>
          </div>
          <div class="table_row">
            <p class="table_name">住所</p>
            <p>{{ registeredData.address }}</p>
          </div>
          <div class="table_row">
            <p class="table_name">建物名</p>
            <p>{{ registeredData.buildingName }}</p>
          </div>
          <div class="table_row">
            <p class="table_name">振込先</p>
            <p>{{ registeredData.creatorType }}</p>
          </div>
          <div v-if="registeredData.creatorType === '法人口座'">
            <div class="table_row">
              <p class="table_name">法人名</p>
              <p>{{ registeredData.companyName }}</p>
            </div>
            <div class="table_row">
              <p class="table_name">適格請求書発行事業者登録番号</p>
              <p>{{ registeredData.invoiceRegistNumber }}</p>
            </div>
          </div>
          <div class="table_row">
            <p class="table_name">本人確認書類及び同意書類</p>
            <div class="file_list_wrap">
              <div v-for="file in registeredFileList" class="file_item">
                {{ file.fileName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <div class="footer">
          <ul>
            <li>登録している本人確認情報に変更が発生した場合、もしくは差戻しされた場合に修正ができます。</li>
            <li>修正する場合には再度登録情報の確認が行われるため、承認処理が完了されるまでは出金申請ができません。</li>
            <li>
              <a href="https://guide.nexon.com/ja/game/rp/guides/jp/pages/401" target="_blank">本人確認情報登録ガイド</a
              >をご確認の上、修正してください。
            </li>
          </ul>
          <button class="btn01 edit_btn" @click="reRegister">登録情報を修正する</button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { NJ_AUTH_STATUS } from '@/utils/variables';

export default {
  name: 'AuthRegisteredView',
  props: {
    registeredData: {
      type: Object,
      default: () => {},
    },
    registeredFileList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    statusClass() {
      switch (this.registeredData.status) {
        case NJ_AUTH_STATUS.IN_PROGRESS:
          return 'progress';
        case NJ_AUTH_STATUS.SUCCESS:
          return 'success';
        default:
          return 'failed';
      }
    },
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    reRegister() {
      if (this.registeredData.status === NJ_AUTH_STATUS.IN_PROGRESS) {
        this.openModal({
          type: 'alert',
          message: this.$t('global.notFinishedReviewAuth'),
        });
      } else {
        this.$router.push({ name: 'AuthRegister', query: { edit: true, ...this.$route.query } });
        window.scrollTo({ top: 0 });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.desc {
  color: #45475a;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  margin-bottom: 40px;
}
.content_wrap {
  /*width: 960px;*/
  border: 1px solid #eee;
  background: #fff;
  padding: 30px;
}
h3 {
  color: #111;
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
}
.progress {
  color: #137fe2;
}
.success {
  color: #40ce98;
}
.failed {
  color: #d83d3f;
}
.line {
  width: 100%;
  height: 1px;
  background: #ddd;
  margin: 30px 0;
}
p {
  color: #666;
  font-size: 13px;
  font-weight: 400;
}
.table_row {
  display: flex;
  margin-bottom: 35.5px;
  gap: 60px;
}
.table_name {
  width: 120px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
.name_text {
  min-width: 60px;
  > span {
    color: #333;
    margin-right: 3px;
  }
}
.file_list_wrap {
  width: calc(100% - 182px);
  height: 120px;
  border: 1px solid #ddd;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #eee;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
  }
}
.file_item {
  height: 40px;
  padding: 8px;
  color: #666;
  font-size: 14px;
  font-weight: 400;
}
.footer {
  height: 123px;
  padding: 30px 34px 30px 26px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
}
a {
  color: #137fe2;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-decoration-line: underline;
}
.edit_btn {
  min-width: 142px;
  height: 40px;
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media all and (max-width: 767px) {
  .desc {
    margin-left: 30px;
  }
  .content_wrap {
    padding: 30px 15px;
  }
  .footer {
    min-height: 187px;
    padding: 30px 54px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 24px;
  }
}

@media all and (max-width: 480px) {
  .desc {
    margin-left: 15px;
  }
  .table_row {
    flex-direction: column;
    margin-bottom: 25px;
    gap: 10px;
  }
  .table_name {
    width: 100%;
  }
  .file_list_wrap {
    width: 100%;
  }
  .footer {
    min-height: 229px;
    padding: 30px 15px;
  }
}

@media all and (max-width: 320px) {
  .footer {
    min-height: 271px;
  }
}
</style>
